import { CitesReleaseSpeciesTransaction } from 'src/app/core/models/cites/cites-release-species/CitesReleaseSpeciesTransaction';
import { ImportProceduresEnum } from '../../release/shared/ImportProceduresEnum';
import { CitesServiceRequestStore } from '../shared/base/CitesServiceRequestStore';

export class CitesReleaseSpeciesStore 
    extends CitesServiceRequestStore<CitesReleaseSpeciesTransaction>{
        readonly importProcedureId: number = ImportProceduresEnum.ImportCitesSpecies;
    }
